export const data = [
    { PDFTitle: "ABC Corporation", CreatedDate: "Jul-15, 2024", Preview: "View", Status: "Draft" },
    {
        PDFTitle: "XYZ Corporation",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Approved"
    },
    {
        PDFTitle: "123 Industries",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Approved"
    },
    { PDFTitle: "Sunrise Co.", CreatedDate: "Jul-15, 2024", Preview: "View", Status: "Draft" },
    {
        PDFTitle: "Moonlight Corp.",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Approved"
    },
    {
        PDFTitle: "Ocean Blue Inc.",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Approved"
    },
    {
        PDFTitle: "Silver Star Enterprises",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Draft"
    },
    {
        PDFTitle: "Golden Gate Corporation",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Draft"
    },
    {
        PDFTitle: "Tech Innovations Ltd.",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Approved"
    },
    {
        PDFTitle: "Global Vision Group",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Approved"
    },
    {
        PDFTitle: "Rainbow Enterprises",
        CreatedDate: "Jul-15, 2024",
        Preview: "View",
        Status: "Draft"
    }
];

export const DUMMY_EMAILS = [
    { label: "john@mail.com", value: "john@mail.com" },
    { label: "jane@mail.com", value: "jane@mail.com" },
    { label: "anna@mail.com", value: "anna@mail.com" },
    { label: "peter@mail.com", value: "peter@mail.com" },
    { label: "sophia@mail.com", value: "sophia@mail.com" },
    { label: "michael@mail.com", value: "michael@mail.com" }
];
